import { useApi } from '@/shared/api/hooks/useApi';

import { useInterwillsActions } from './useInterwillActions';

export const useRemoveParticipantRole = () => {
  const api = useApi();
  const actions = useInterwillsActions();

  return async (centralDbProfileId: number | undefined) => {
    const resWill = await actions.getInterwill();

    if (resWill?.centralDbInterwillId && centralDbProfileId) {
      const res = await api.willsGet(resWill?.centralDbInterwillId);
      if (res.data && !res.error) {
        const will = res.data;
        const participant = will?.participants.find((p) => p.profileId === centralDbProfileId);

        if (participant) {
          return await api.willsRemoveParticipant(resWill.centralDbInterwillId, participant.id);
        }
      }
    }
    return null;
  };
};
